import { Directive, OnInit, AfterViewInit, ElementRef, ViewChild, Input, AfterViewChecked, HostListener, EventEmitter, Output, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgReallyActionComponent } from "./ng-really-click.component";
import * as _ from "lodash-es";
//import { GlobalService } from "../../../global/services/global.service";
import { NgReallyClickService } from "./ng-really-click.service";

@Directive({
    selector: '[ng-really-click]',
    standalone: false
})
  export class ngReallyClickDirective{
  private readonly destroyRef = inject(DestroyRef);


    @Input()
    ngReallyMessage:any;
    @Input()
    ngReallyHeader:any;
    @Input()
    ngReallyOk:any;
    @Input()
    ngReallyClick:any;
    @Input()
    ngReallyNo:any
    @Input()
    isIssueChangeAction:any;
    @Input()
    globalIssue:any;
    @Input()
    rowIssueId:any;
    @Output()
    reallyOkay: EventEmitter<any> = new EventEmitter();
    
    constructor(public dialog:MatDialog,
      public element:ElementRef,
      //private globalService: GlobalService,
      private ngReallyService: NgReallyClickService){
      //console.log('dial',this.element);
    }
    @HostListener('click', ['$event']) 
    onClick(e:Event) {
      console.log('event click',e);
      let isTypeOk = this.ngReallyOk;
      let clickAction = this.ngReallyClick;
      let clickCancel = this.ngReallyNo;
      let isIssueChangeAction = this.isIssueChangeAction;
      let globalIssue = this.globalIssue;
      let rowIssueId = this.rowIssueId;

    this.ngReallyService.openNgReallyDialog(this.ngReallyHeader,this.ngReallyMessage,this.isIssueChangeAction,this.ngReallyOk)
      .afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result:any)=>{
        console.log('this',result);
        if(_.isObject(result)){
          /* need to look  if(result.isGlobalIssues){
              this.globalService.global.globalParams.issue_id_for_tx_save = this.globalIssue;

            }else{
              this.globalService.global.globalParams.issue_id_for_tx_save = this.rowIssueId;

            } */
        }else if(result){
           this.reallyOkay.emit();
        }

      })
    }
  
  }  